import { FC } from 'react';
import IconPercentageArrowUp from '@shared/icons/IconPercentageArrowUp';
import IconPercentageArrowDown from '@shared/icons/IconPercentageArrowDown';

interface IPercentageMonitorProps {
  value: number;
  mode: 'up' | 'down';
}

const PercentageMonitor: FC<IPercentageMonitorProps> = ({ value, mode }) => {
  return (
    <span
      className={`${mode === 'up' ? 'text-[#29A70F]' : 'text-[red]'} flex gap-[5px] items-center`}
    >
      {mode === 'up' ? <IconPercentageArrowUp /> : <IconPercentageArrowDown />}
      {mode === 'down' ? value * -1 : value}%
    </span>
  );
};

export default PercentageMonitor;
